<div class="page-title">Criar novo grupo de precificação</div>

<form [formGroup]="groupForm" class="form-b4a" (submit)="submit()">
  <p-fieldset legend="Informações básicas" class="w-full">
    <span class="p-float-label w-full">
      <input
        id="name"
        type="text"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('name')
        }"
        pInputText
        formControlName="name"
      />
      <label for="name">Nome *</label>
      <ng-container *ngIf="invalidControl('name')">
        <small
          class="error"
          *ngIf="groupForm.controls['name'].error?.required"
          class="invalid-feedback"
        >
          Obrigatório
        </small>
      </ng-container>
    </span>

    <span class="p-float-label w-full">
      <input
        id="description"
        type="text"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('description')
        }"
        pInputText
        formControlName="description"
      />
      <label for="description">Descrição</label>
      <ng-container *ngIf="invalidControl('description')">
        <small
          class="error"
          *ngIf="groupForm.controls['description'].error?.required"
          class="invalid-feedback"
        >
          Obrigatório
        </small>
      </ng-container>
    </span>

    <span class="p-float-label">
      <p-inputNumber
        id="markupMin"
        type="number"
        formControlName="markupMin"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [max]="100"
        [min]="0.1"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('markupMin')
        }"
      />
      <label for="markupMin">Markup Mínimo *</label>
      <ng-container *ngIf="invalidControl('markupMin')">
        <small
          class="error"
          *ngIf="groupForm.controls['markupMin'].error?.required"
          class="invalid-feedback"
        >
          Obrigatório
        </small>
        <small
          class="error"
          *ngIf="groupForm.controls['markupMin'].error?.min"
          class="invalid-feedback"
        >
          Valor invalido
        </small>
      </ng-container>
    </span>

    <span class="p-float-label">
      <p-inputNumber
        id="markupWithoutCompetitor"
        type="number"
        formControlName="markupWithoutCompetitor"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [max]="100"
        [min]="0.1"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('markupWithoutCompetitor')
        }"
      />
      <label for="markupWithoutCompetitor">Markup sem Concorrente *</label>
    </span>

    <span class="p-float-label">
      <p-inputNumber
        id="discountCompetitor"
        type="number"
        suffix="%"
        formControlName="discountCompetitor"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [max]="100"
        [min]="0.1"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('discountCompetitor')
        }"
      />
      <label for="discountCompetitor">Desconto Concorrente (%) *</label>
    </span>

    <span class="p-float-label">
      <p-inputNumber
        id="subscriberDiscountPercentage"
        type="number"
        suffix="%"
        formControlName="subscriberDiscountPercentage"
        [maxFractionDigits]="2"
        [minFractionDigits]="2"
        [max]="100"
        [min]="0.1"
        [ngClass]="{
          'ng-invalid ng-dirty': invalidControl('subscriberDiscountPercentage')
        }"
      />
      <label for="subscriberDiscountPercentage">Desconto Assinante (%) *</label>
    </span>

    <span class="p-input-checkbox">
      <p-checkbox
        formControlName="dynamicPrecification"
        [binary]="true"
        inputId="dynamicPrecification"
      />
      <label for="dynamicPrecification">Precificação automática</label>
    </span>
  </p-fieldset>

  <div class="form-footer">
    <div class="action">
      <p-button
        type="submit"
        pRipple
        label="Salvar"
        severity="primary"
        [disabled]="groupForm.invalid"
      />
    </div>
  </div>
</form>
